import { QueryClient } from '@tanstack/react-query';
import { hashKey } from '@tanstack/query-core';

export const ACTIVE_EMPRESA_STORAGE_KEY = 'active_empresa_id';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Separa cache do React Query por empresa ativa sem exigir mudar queryKey em cada tela.
      // IMPORTANTE: lê localStorage (não sessionStorage) para funcionar em tabs distintas.
      queryKeyHashFn: (queryKey) => {
        const empresaId = typeof window !== 'undefined'
          ? localStorage.getItem(ACTIVE_EMPRESA_STORAGE_KEY) || 'sem-empresa'
          : 'ssr';
        return `${empresaId}::${hashKey(queryKey)}`;
      },
      // Não retentar em erros 4xx — erros de negócio não são transitórios.
      retry: (failureCount, error) => {
        const status = (error as { response?: { status?: number } })?.response?.status;
        if (status && status >= 400 && status < 500) return false;
        return failureCount < 1;
      },
    },
    mutations: {
      // Mutations nunca retentar automaticamente — evita duplicação de dados.
      retry: false,
    },
  },
});
